import SessionsBase from '@/components/SessionsBase'
import SessionsList from '@/components/SessionsList'

export default {
  components: { SessionsBase, SessionsList },

  props: {
    slug: {
      type: String,
      required: false,
      default: '',
    },
  },
}
